import { config } from '@fortawesome/fontawesome-svg-core'

// Disable automatic addition of FontAwesome CSS to avoid duplicate styles.
export default defineNuxtPlugin(() => {
  config.autoAddCss = false
})
